import React from "react";
import { useMatch, useResolvedPath, useNavigate } from "react-router-dom";
import styles from "./index.module.css";

interface NavMenuLinkProps {
  children?: React.ReactNode;
  to: string;
  disabled?: boolean;
  before?: boolean;
  after?: boolean;
  onClick?: () => void;
  className?: string;
}

export const NavMenuLink: React.FC<NavMenuLinkProps> = ({
  children,
  to,
  onClick,
  before,
  after,
  disabled,
  className,
}) => {
  const navigate = useNavigate();
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: true });
  const isActive = !!match;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) onClick();
    if (!e.defaultPrevented && !disabled) {
      e.preventDefault();
      navigate(to);
    }
  };

  return (
    <mui-link
      href={to}
      disabled={disabled}
      variant={isActive ? "primary" : "secondary"}
      class={`
        ${styles.navLink}
        ${className || ""}
      `}
      onClick={handleClick}
    >
      {children}
    </mui-link>
  );
};
